import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["allAgree", "term", "warning", "submitButton"]

  connect() {
    this.updateSubmitButton()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.termTargets.forEach(term => {
      term.checked = checked
    })
    this.updateSubmitButton()
    this.hideWarning()
  }

  updateAll() {
    const allChecked = this.termTargets.every(term => term.checked)
    this.allAgreeTarget.checked = allChecked
    this.updateSubmitButton()

    if (this.requiredTermsChecked()) {
      this.hideWarning()
    }
  }

  requiredTermsChecked() {
    return this.termTargets
      .filter(term => term.dataset.required === "true")
      .every(term => term.checked)
  }

  updateSubmitButton() {
    const isValid = this.requiredTermsChecked()
    this.submitButtonTarget.disabled = !isValid
  }

  showWarning() {
    this.warningTarget.classList.remove("hidden")
  }

  hideWarning() {
    this.warningTarget.classList.add("hidden")
  }

  // 제출은 브라우저가 한다 — 이 화면은 진짜 form 이고 [다음 단계]는 submit 버튼이다.
  // 예전에는 여기서 sessionStorage 에 담고 location 을 바꿨는데, 그러면 서버가 동의를
  // 알 수 없어 가입 폼 직행을 막을 수 없었다. 서버가 검증·저장하므로 JS 는 필수 항목이
  // 다 체크됐는지에 따라 버튼을 켜고 끄는 것만 한다(updateSubmitButton).
}
